import * as React from 'react'

import { observer } from 'mobx-react'

import {
  Drawer,
  DrawerContent,
  DrawerTitle,
} from '~/client/src/shared/components/shadcn-ui/drawer'
import { HostPortalContainerContext } from '~/client/src/shared/utils/hostPortalContainer'

import StackList, { IStackListProps, StackListHeader } from './StackList'

interface IProps extends IStackListProps {
  isOpen: boolean
  onClosed: () => void
}

// localization: no text to translate

// noBodyStyles: vaul's fixed <body> collapses the map's AutoSizer under the sheet (STX1-443).
// Rows, map links and the map menu's items grow to a 44px touch target. The menu portals into
// the sheet: outside it, the modal sheet would swallow the tap.
// vaul's slide: 0.5s.
const SHEET_CLOSE_MS = 500

const StackDrawer: React.FC<IProps> = ({ isOpen, onClosed, ...listProps }) => {
  const { rows, workflows, getLocation, onClose } = listProps
  const portalRef = React.useRef<HTMLDivElement>(null)
  // vaul reports the end only of the closes it starts itself, so a close from the list (its ✕, a
  // row pick) is timed out instead: the list is let go once the sheet has slid away.
  React.useEffect(() => {
    if (isOpen) return undefined
    const timer = window.setTimeout(onClosed, SHEET_CLOSE_MS)
    return () => window.clearTimeout(timer)
  }, [isOpen, onClosed])

  return (
    <Drawer
      open={isOpen}
      onOpenChange={open => !open && onClose()}
      noBodyStyles
    >
      <DrawerContent
        aria-describedby={undefined}
        className="tw:[&_[data-slot=dropdown-menu-item]]:min-h-11 tw:[&_[data-stack-close]]:size-11"
      >
        <StackListHeader
          rows={rows}
          workflowCount={workflows.length}
          getLocation={getLocation}
          onClose={onClose}
          titleAs={DrawerTitle}
        />
        <div className="tw:min-h-0 tw:overflow-y-auto tw:px-2 tw:[&_[data-stack-row]]:min-h-11 tw:[&_[data-stack-map-link]]:size-11">
          <HostPortalContainerContext.Provider value={portalRef}>
            <StackList {...listProps} />
          </HostPortalContainerContext.Provider>
        </div>
        <div ref={portalRef} />
      </DrawerContent>
    </Drawer>
  )
}

export default observer(StackDrawer)
